import React from 'react';
import { useRecoilValue } from 'recoil';
import AccessInfoSelector from '../../recoil/selectors/AccessInfoSelector';

export default function CreditCoin() {
  const { network } = useRecoilValue(AccessInfoSelector);

  if (network === 'lovoo') {
    return (
      <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?%CB%#ic_lv_claim_credit" /></svg>
    );
  }

  return (
    <img src="/img/icons/purchase/credit.svg" alt="" />
  );
}
